(function () {
  'use strict';

  // todo: rename to LineSigma as it's not necessarily a Delta
  d3.chart('Plot').extend('DeltaSigma', {
    initialize : function (options) {
      var plot = this;
      options = options || {};

      // defaults so if options set any in Plot we don't override them
      _.defaults(plot.defaultFns, {
        // the value of 1 sigma
        sigma : function (d) { return d.sigma; },
        // the confidence threshold factor
        confidence : function (d) { return 1; },
        // the low side of the confidence interval
        y0 : function (d) { return plot.fn.y(d) - plot.fn.confidence(d) * plot.fn.sigma(d); },
        // the high side of the confidence interval
        y1 : function (d) { return plot.fn.y(d) + plot.fn.confidence(d) * plot.fn.sigma(d); }
      });

      plot.layers = {
        sigma : plot.viz.append('g').classed('series sigma', true),
        delta : plot.viz.append('g').classed('series delta', true)
      };

      plot.line = d3.svg.line()
          .x(function (d) { return plot.x(plot.fn.x(d)); })
          .y(function (d) { return plot.y(plot.fn.y(d)); });

      plot.area = d3.svg.area()
          .x(function (d) { return plot.x(plot.fn.x(d)); })
          .y0(function (d) { return plot.y(plot.fn.y0(d)); })
          .y1(function (d) { return plot.y(plot.fn.y1(d)); });

      plot.layer('delta', plot.layers.delta, {
        dataBind : function (data) {
          return this.selectAll('path')
              .data([data.series[0]]);
        },
        insert : function () {
          return this.append('path');
        },
        events : {
          merge : function () {
            this
                .attr('d', plot.withSeries(function () {
                  return plot.line(plot.data.data);
                }))
                .style('stroke', function (series) {
                  return plot.color(series.name);
                })
          }
        }
      });

      plot.layer('sigma', plot.layers.sigma, {
        dataBind : function (data) {
          return this.selectAll('path')
              .data([data.series[1]]);
        },
        insert : function () {
          return this.insert('path');
        },
        events : {
          merge : function () {
            this
                .attr('d', plot.withSeries(function () {
                  return plot.area(plot.data.data);
                }))
                .style('fill', function (series) {
                  return plot.color(series.name);
                })
          }
        }
      });

      plot
          .on('change:clip', function () {
            plot.wrap.selectAll('.series path')
                .style('clip-path', 'url(#' + plot.clipperId + ')');
          });
    },
    transform : function (data) {
      var plot = this;

      if (data !== plot.data) {
        plot.setData(data);

        plot.withSeries(data.series[1], function () {
          var yDomain = _.map({
            min : 'y0',
            max : 'y1'
          }, function (yFn, minOrMax) {
            var setValue = plot.yDomain[minOrMax];
            return !_.isUndefined(setValue) ? setValue :
                d3[minOrMax](data.data.map(plot.fn[yFn]));
          });

          plot.setYDomain(yDomain);
        });
      }

      return data;
    }
  });

})();
